import { render, staticRenderFns } from "./FlowinityAuthorize.vue?vue&type=template&id=76622207&scoped=true"
import script from "./FlowinityAuthorize.vue?vue&type=script&lang=js"
export * from "./FlowinityAuthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76622207",
  null
  
)

export default component.exports